module.exports = __webpack_public_path__ + "src/assets/img/index_img3.27e53048.jpg";